<div *ngIf="messages.length > 0" class="check-flex-col check-place-content-center-space-around">
  <div *ngFor="let message of messages"
       [innerHTML]="message.label"
       class="alert alert-{{ message.error ? 'error' : (message.warning ? 'warn' : 'success') }}">
  </div>
</div>
